var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { default as AntSwitch } from 'antd/lib/switch';
import { basicPropTypes, controlPropTypes } from '../component-props';
/**
 * 开关选择器。
 */

var Switch = function (_super) {
  __extends(Switch, _super);

  function Switch(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  Switch.prototype.handleChange = function (checked) {
    var _a = this.props,
        onChange = _a.onChange,
        name = _a.name;

    if (onChange) {
      onChange(checked, name);
    }
  };

  Switch.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        name = _a.name,
        value = _a.value,
        disabled = _a.disabled,
        checkedChildren = _a.checkedChildren,
        unCheckedChildren = _a.unCheckedChildren;
    var switchProps = {
      // basicPropTypes
      className: className,
      style: style,
      // controlPropTypes
      name: name,
      checked: value,
      disabled: disabled,
      onChange: this.handleChange,
      // custom
      checkedChildren: checkedChildren,
      unCheckedChildren: unCheckedChildren
    };
    return React.createElement(AntSwitch, __assign({}, switchProps));
  };

  Switch.propTypes = __assign(__assign(__assign({}, basicPropTypes), controlPropTypes), {
    value: PropTypes.bool
  });
  return Switch;
}(PureComponent);

export { Switch };